/* eslint-disable react-hooks/exhaustive-deps */
import { useRef } from 'react';
import CustomAlert from '@components/Shared/Alert/CustomAlert';

import ItemsColumn from './ItemsColumn';
import SettingsColumn from './SettingsColumn';
import PrintArea from './PrintArea';

import { usePriceListBarcodePrint } from './usePriceListBarcodePrint';

export default function PriceListBarcodePrint() {
  const vm = usePriceListBarcodePrint();
  const printRef = useRef<HTMLDivElement | null>(null);

  const buildPrintCss = () => {
    const pageSizeCss = vm.paperMode === 'A4' ? 'A4 portrait' : 'auto';
    const dir = vm.language === 'en' ? 'ltr' : 'rtl';

    return `
      @page { size: ${pageSizeCss}; margin: 0mm; }
      * { box-sizing: border-box; }
      body { margin: 0; padding: 0; font-family: Arial, Tahoma, sans-serif; }
      .sheet { padding: ${vm.layout.gapMm}mm; }
      .grid { display: flex; flex-wrap: wrap; gap: ${vm.layout.gapMm}mm; direction: ${dir}; }
      .labelAbs {
        width: ${vm.layout.labelWmm}mm;
        height: ${vm.layout.labelHmm}mm;
        position: relative;
        overflow: hidden;
        border: 0.2mm solid rgba(0,0,0,0.15);
        page-break-inside: avoid;
      }
      svg { max-width: 100%; }
    `;
  };

  const onPrint = () => {
    if (!vm.labels.length) {
      CustomAlert({ action: 'info', msg: 'اختر صنف وحدد كمية ثم اطبع' });
      return;
    }
    if (!printRef.current) return;

    const html = `
      <html>
        <head>
          <title>Barcode Print</title>
          <style>${buildPrintCss()}</style>
        </head>
        <body>
          ${printRef.current.innerHTML}
          <script>
            window.onload = function(){
              try { window.focus(); window.print(); } catch(e){}
            }
          </script>
        </body>
      </html>
    `;

    const w = window.open('', '_blank', 'width=1000,height=800');
    if (!w) {
      CustomAlert({ action: 'Error', msg: 'المتصفح منع فتح نافذة الطباعة (Popup Blocker)' });
      return;
    }
    w.document.open();
    w.document.write(html);
    w.document.close();
  };

  return (
    <div className='px-2'>
      <div className='row'>
        <ItemsColumn vm={vm} />
        <SettingsColumn vm={vm} onPrint={onPrint} />
      </div>

      <PrintArea
        printRef={printRef}
        labels={vm.labels}
        layout={vm.layout}
        showName={vm.showName}
        showCode={vm.showCode}
        showUom={vm.showUom}
        showPrice={vm.showPrice}
        showBarcodeText={vm.showBarcodeText}
        currency={vm.currency}
        getDisplayName={vm.getDisplayName}
        getDisplayUom={vm.getDisplayUom}
      />
    </div>
  );
}
